<template>
    <div class="hot_spot_type" v-loading="loading">
        <div class="hot_spot_type1">
            <div class="hot_spot_type_box1">
                <div class="title_box">
                    <img src="@/assets/img/login/Frame.png" alt="">
                    <span class="span1">首页</span> > <span class="span2">{{type_detial.title||''}}</span>
                </div>
                <div class="banner_box">
                    <div class="banner_imgs">
                        <el-carousel>
                            <el-carousel-item v-for="(item,index) in banner_list" :key="index">
                                <div class="imgs_box" @click="handle_detial(item)">
                                    <!-- <img src="../../../assets/img/index/legal/bg1.png" alt=""> -->
                                     <img :src="item.thumb" alt="">
                                    <div class="img_texts">
                                        <!-- 离婚后夫妻财产如何分割 -->
                                        {{ item.title }}
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div class="banner_types">
                        <div class="types_left">
                            <div class="title_img">
                                <img src="../../../assets/img/index/home/type_gr1.png" alt="">
                                {{type_detial.title}}专区
                            </div>
                            <div class="type_const">
                                {{type_detial.description}}
                            </div>
                            <div class="type_text1"><span>{{ type_list.length }}</span>细分领域</div>
                            <div class="type_text2"><span>{{ total }}</span>+精选文章</div>
                        </div>
                        <div class="types_right">
                            <div class="teges" v-for="(item, index) in type_list" :key="index">
                                {{ item.title }}
                            </div>
                            <div class="teges2" v-for="(item, index) in 4" ></div>
                            <!-- :key="index" -->
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="hot_spot_type2">
            <div class="hot_spot_type_box2">
                <div class="lists_new">
                    <div class="lists_box">
                        <div class="list_item">
                            <div class="items" v-for="(item, index) in new_list" :key="index" @click="handle_detial(item)">
                                <div class="item_imgs">
                                    <!-- <img src="../../../assets/img/index/legal/bg1.png" alt=""> -->
                                     <img :src="item.thumb" alt="">
                                </div>
                                <div class="item_info">
                                    <div class="info_top">
                                        <div class="item_titles">
                                            {{ item.title }}
                                        </div>
                                        <div class="item_const">
                                            {{ item.description }}
                                        </div>
                                    </div>
                                    <div class="info_bom">
                                        <div class="item_icons">
                                            <div class="icons">
                                                #{{ item.category.title }}
                                            </div>
                                            <div class="icons">
                                                <img src="../../../assets/img/index/comments_case/see.png" alt="">
                                                {{ item.view_num }}
                                            </div>
                                            <div class="icons">
                                                <img src="../../../assets/img/index/comments_case/time.png" alt="">
                                                {{ item.created_at }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pages_box">
                            <div class="btns" @click="handle_pages(1)">首页</div>
                            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                :current-page="pages.page" background :page-size="pages.limit"
                                layout="prev, pager, next" :total="total">
                            </el-pagination>
                            <div class="btns" @click="handle_pages(last_page)">尾页</div>
                        </div>
                    </div>
                    <div class="new_box">
                        <hot_spot_new ref="hot_spot_new"></hot_spot_new>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { useListeners } from 'vue';
import {
    mapState
} from 'vuex'

import hot_spot_new from '@/components/law/hot_spot/hot_spo_new.vue'//右边


export default {
    components: {
        hot_spot_new

    },
    name: "homes",
    data() {
        return {
            loading: false,
            total: 0,
            type_detial:{},
            type_list:[],
            new_list:[],
            last_page:0,
            pages: {
                page: 1,
                limit: 10,
            },
        }
    },
    computed: {
        banner_list(){
            let list =[]
            this.new_list.forEach((e,i)=>{
                if(i<5){
                    list.push(e)
                }
            })
            return list
        }
    },
    watch: {

    },
    created() {
        this.get_type()
        this.get_type_list()
        this.get_new_list()
    },
    methods: {
        handleSizeChange(e) {
            console.log('条数', e)
        },
        handleCurrentChange(e) {
            console.log('页数', e)
        },
        handle_pages(i) {
            console.log('首页尾页', i)
            this.pages.page = i
        },
        handle_detial(item){
            this.$router.push({
                path:'/hot_spot_type_detial',
                query:{
                    id:item.id
                }
            })
        },
        get_type(){
            this.loading=true
            let parent_id=19
            if(this.$route.query.parent_id){
                parent_id=this.$route.query.parent_id
            }
            this.$api("getArticleCategoryList", {
                parent_id:parent_id,
			}, "get").then((res) => {
                this.loading = false
                console.log('分类详情',res)
                if (res.code == 1) {
                 res.data.forEach((e)=>{
                    if(e.id==this.$route.query.id){
                        console.log('e',e)
                        this.type_detial=e
                    }
                 })
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_type_list(){
            this.loading=true
            this.$api("getArticleCategoryList", {
                parent_id:this.$route.query.id,
			}, "get").then((res) => {
                this.loading = false
                console.log('分类的下级列表',res)
                if (res.code == 1) {
                    this.type_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_new_list(){
            this.loading=true
            this.$api("getArticleList", {
                category_id:this.$route.query.id,
                ...this.pages,
			}, "get").then((res) => {
                this.loading = false
                console.log('新闻列表',res)
                if (res.code == 1) {
                    this.new_list=res.data.list
                    this.total=res.data.count
                    this.last_page=Math.ceil(res.data.count/this.pages.limit)
                    
                    
                } else {
                    alertErr(res.msg)
                }
            });
        },
    },

}
</script>
<style scoped lang="less">
.hot_spot_type {
    width: 100%;

    .hot_spot_type1 {
        background-color: #F5F5F5;

        .hot_spot_type_box1 {

            width: 1440px;
            margin: auto;
            padding-top: 20px;
            padding-bottom: 40px;

            .title_box {
                padding-bottom: 21px;

                display: flex;
                align-items: center;

                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;

                .span1 {
                    cursor: pointer;
                    margin-right: 10px;
                }

                .span2 {
                    cursor: pointer;
                    margin-left: 10px;
                }

                img {
                    margin-right: 10px;
                }
            }

            .banner_box {
                display: flex;
                align-items: center;

                .banner_imgs {
                    width: 420px;
                    height: 280px;
                    border-radius: 0px 0px 0px 0px;

                    /deep/.el-carousel {
                        width: 420px;
                        height: 280px;

                        .el-carousel__container {
                            width: 420px;
                            height: 280px;

                            .el-carousel__item {
                                width: 420px;
                                height: 280px;

                                .imgs_box {
                                    width: 420px;
                                    height: 280px;
                                    position: relative;
                                    cursor: pointer;

                                    img {
                                        width: 420px;
                                        height: 280px;
                                    }

                                    .img_texts {
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: bold;
                                        font-size: 18px;
                                        color: #FFFFFF;
                                        position: absolute;
                                        left: 20px;
                                        bottom: 40px;
                                        width: 400px;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        display: -webkit-box;
                                        -webkit-line-clamp:1;
                                        -webkit-box-orient: vertical;
                                    }
                                }

                            }
                        }

                        .el-carousel__indicators {
                            width: 100%;
                            justify-content: end;
                            padding: 0 20px;

                            .el-carousel__indicator {
                                .el-carousel__button {
                                    width: 10px;
                                    height: 10px;
                                    background: #FFFFFF;
                                    border-radius: 50%;
                                }
                            }

                            .is-active {
                                .el-carousel__button {
                                    width: 40px;
                                    height: 10px;
                                    background: #377CFD;
                                    border-radius: 5px 5px 5px 5px;
                                }
                            }
                        }
                    }
                }

                .banner_types {
                    width: 100%;
                    min-height: 280px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    margin-left: 24px;
                    padding: 40px;
                    display: flex;

                    // align-items: center;
                    .types_left {
                        width: 320px;
                        flex-shrink: 0;
                        border-right: 1px solid #EDEDED;

                        .title_img {
                            display: flex;
                            align-items: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 24px;
                            color: #333333;

                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 24px;
                            color: #333333;

                            img {
                                width: 32px;
                                height: 26px;
                                margin-right: 10px;
                            }
                        }

                        .type_const {
                            padding-top: 15px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;

                        }

                        .type_text1 {

                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            padding-top: 40px;

                            span {
                                color: #333333;
                                font-size: 36px;
                                font-weight: bold;
                            }

                        }

                        .type_text2 {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            margin-top: 10px;

                            span {
                                color: #333333;
                                font-size: 36px;
                                font-weight: bold;
                            }
                        }

                    }

                    .types_right {
                        padding-left: 40px;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        justify-content: space-between;

                        .teges {
                            width: 128px;
                            height: 36px;
                            background: #F5F5F5;
                            border-radius: 18px 18px 18px 18px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            text-align: center;
                            line-height: 36px;
                        }

                        .teges2 {
                            width: 128px;

                        }
                    }
                }
            }

        }
    }

    .hot_spot_type2 {
        .hot_spot_type_box2 {
            width: 1440px;
            margin: auto;
            background: #FFFFFF;

            .lists_new {
                display: flex;
                // align-items: center;
                padding-top: 36px;
                background: #FFFFFF;

                .lists_box {
                    padding-right: 40px;
                    .list_item {
                        width: 984px;

                        .items {
                            margin-bottom: 32px;
                            padding-bottom: 32px;
                            border-bottom: 1px solid #EEEEEE;
                            display: flex;
                            cursor: pointer;
                            .item_imgs {
                                width: 300px;
                                height: 200px;
                                flex-shrink: 0;
                                border-radius: 0px 0px 0px 0px;

                                img {
                                    width: 300px;
                                    height: 200px;
                                }
                            }

                            .item_info {
                                padding: 10px 0;
                                padding-left: 24px;
                                height: 200px;
                                display: flex;
                                align-content: space-between;
                                flex-wrap: wrap;

                                .info_top {
                                    .item_titles {
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: bold;
                                        font-size: 18px;
                                        color: #333333;
                                    }

                                    .item_const {
                                        padding-top: 16px;
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #999999;

                                    }
                                }

                                .info_bom {
                                    .item_icons {
                                        display: flex;
                                        align-items: center;

                                        .icons {
                                            display: flex;
                                            align-items: center;
                                            margin-right: 24px;
                                            font-family: Microsoft YaHei, Microsoft YaHei;
                                            font-weight: 400;
                                            font-size: 14px;
                                            color: #999999;

                                            img {
                                                height: 15px;
                                                margin-right: 5px;
                                            }
                                        }
                                    }
                                }

                            }
                        }
                    }

                    .pages_box {
                        width: 100%;
                        height: 100px;
                        // background-color: red;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        /deep/.el-pagination {
                            .el-pager {
                                .number {
                                    background-color: #FFFFFF;
                                }

                                .active {
                                    background-color: #377CFD;
                                }
                            }
                        }

                        .btns {
                            width: 40px;
                            height: 32px;
                            background: #FFFFFF;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #EEEEEE;
                            font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                            font-weight: normal;
                            font-size: 14px;
                            color: #7A7A7A;
                            text-align: center;
                            line-height: 32px;
                            cursor: pointer;
                        }
                    }
                }

                .new_box {}
            }
        }
    }

}
</style>